import React from "react";
import styled from "styled-components";
import checkboxSvg from "assets/icons/checkbox.svg";
import { flexBox } from "styles/mixins";
import { RowWithArrow, Row } from "styles/common/NavigationStyle";
import useModalStore from "store/modal";

const CheckboxContainer = styled.div`
  ${flexBox("row", "flex-start", "center", "4px")}
  margin-bottom: ${(props) => props.marginBottom || "14px"};

  label {
    ${flexBox("column", "center", "center", "4px")}
    color: var(--black-font-color, #222);
  }

  input[type="checkbox"] {
    display: none;
  }

  div {
    display: inline-block;
    width: 18px;
    height: 18px;
    border-radius: 2px;
    box-shadow: inset 0 0 0 2px #959595;
    cursor: pointer;
    margin-right: 3px;

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
`;

const Checkbox = ({
  label,
  id,
  name,
  checked,
  onChange,
  marginBottom,
  href,
}) => {
  const modalStore = useModalStore();

  const openModal = (e) => {
    e.preventDefault();
    modalStore.openModal({ content: href });
  };

  return (
    <CheckboxContainer marginBottom={marginBottom}>
      <label>
        <input id={id} name={name} type="checkbox" onChange={onChange} />
        <div>{checked && <img src={checkboxSvg} alt="checkbox" />}</div>
      </label>
      {href ? (
        <RowWithArrow onClick={openModal} height="20px">
          {label}
        </RowWithArrow>
      ) : (
        <Row height="20px">{label}</Row>
      )}
    </CheckboxContainer>
  );
};

export default Checkbox;
